import RecordsPage from '../common/RecordsPage';
import type { FinanceCtx } from '../financeApi';

export default function ExpenseRecords({ ctx }: { ctx: FinanceCtx }) {
  return <RecordsPage ctx={ctx} type="지출" />;
}
